
const lbaPointsOfInterest = angular.module('app.lbaPointsOfInterest', [
  require('../lbaPointsOfInterestList/lbaPointsOfInterestList').name,
  require('../lbaPointsOfInterestItemForm/lbaPointsOfInterestItemForm').name,
  require('../lbaLeafletMap').name
]);

lbaPointsOfInterest.controller('lbaPointsOfInterestCtrl', require('./lbaPointsOfInterestCtrl'));
lbaPointsOfInterest.directive('lbaPointsOfInterest', require('./lbaPointsOfInterestDir'));
lbaPointsOfInterest.service('pointsOfInterestService', require('../../services/pointsOfInterestService'));
lbaPointsOfInterest.service('lbaLeafletMapService', require('../../services/lbaLeafletMapService'));

export default lbaPointsOfInterest;




// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterest/index.js